import React from "react";
import { Anchor } from "@ebscois/react-component-library";
import { getMerativeLinkWithToken } from "../../../store/actions";
import { affordances, logDrugConsultsClicked } from "../../../util/analytics";

export const drugConsultLinkProcessor = ({
  dispatch,
  drugConsultUrlTemplate,
  telemetryData,
}) => {
  const buildUrl = (docId) => {
    return drugConsultUrlTemplate?.replace(/\${docId}/, docId);
  };
  return {
    replaceChildren: true,
    shouldProcessNode: (node) =>
      node.attribs && node.attribs["data-transform"] === "drug-consult-link",
    processNode: (node) => {
      const amplitudeEventObject = {
        ...telemetryData,
        affordance: affordances.DRUG_MONOGRAPH_INLINE,
        navigateFrom: "Drug Monograph",
        docId: node.attribs["data-value"],
        drugConsultTitle: node.attribs["data-title"],
      };
      return (
        <Anchor
          href={buildUrl(node.attribs["data-value"])}
          onClick={async (e) => {
            e.preventDefault();
            if (e.button !== 1) {
              logDrugConsultsClicked(amplitudeEventObject);
              await getMerativeLinkWithToken(
                dispatch,
                buildUrl(node.attribs["data-value"])
              );
            }
          }}
        >
          {node.attribs["data-title"]}
          <svg class="external-link-icon">
            <use href="#external-launch" />
          </svg>
        </Anchor>
      );
    },
  };
};
